<template>
  <div class="to-cart">
    <ui-button
      class="to-cart__button"
      :text="text"
      :icon="icon"
      :loading="progress"
      :large="large"
      wide
      @click="handleAdd"
      :disabled="isDisabled"
    />

    <slot />

    <ui-notification
      v-if="!hideNotification && !skuId && product.available"
      ref="notification"
      title="Необходимо выбрать размер"
    >
      Чтобы заказать товар онлайн с безопасной доставкой курьером или с самовывозом
    </ui-notification>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { getCsmToken } from '@/utils/csm-cookies';

import IconCart from '@icons/cart.svg';
import IconSuccess from '@icons/success.svg';
import { commonGtmEvents } from '@/gtm/common-gtm-events';
import { cartGtmEvents } from '@/gtm/cart-gtm-events';

export default {
  name: 'to-cart',

  icons: {
    IconCart,
    IconSuccess,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    skuId: {
      type: [String, Number],
      default: '',
    },
    storeId: {
      type: [String, Number],
      default: '',
    },
    textAdd: {
      type: String,
      default: 'Добавить в корзину',
    },
    textAdded: {
      type: String,
      default: 'Товар добавлен',
    },
    hideNotification: {
      type: Boolean,
      default: false,
    },
    hideIcons: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: () => true,
    },
    forceEnabled: {
      type: Boolean,
      default: false,
    },
    price: {
      type: String,
      default: "",
    },
    discountPrice: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    progress: false,
    success: false,
    csmToken: getCsmToken(),
  }),

  computed: {
    ...mapGetters({
      CART: 'cart/products',
    }),
    icon() {
      if (this.hideIcons) return '';
      return this.success
        ? IconSuccess.id
        : IconCart.id
      ;
    },
    text() {
      return this.success
        ? this.textAdded
        : this.textAdd
      ;
    },
    isDisabled() {
      if (this.forceEnabled && this.product.available) {
        return false;
      }

      return !this.product.available || (this.hideNotification && !this.skuId);
    },
  },

  watch: {
    skuId() {
      this.success = false;
    },
  },

  methods: {
    ...mapActions({
      ADD_TO_CART: 'cart/add',
      ADD_TO_CSM_CART: 'cart/addCsm',
    }),
    handleAddPromise(promise) {
      this.progress = true;

      promise.then(() => {
        setTimeout(() => {
          this.progress = false;
          this.success = true;
          this.$emit('added');
        }, 500);
      }).catch(() => {
        this.progress = false;
        this.$store.dispatch('notifications/create', {
          title: 'Ошибка',
          message: 'Не удалось добавить в корзину. Повторите запрос позже.',
        });
      });
    },
    addCsmToCart() {
      if (!this.skuId) {
        this.$emit('no-size-submit');

        this.$refs.notification?.shake();
        return;
      }

      this.handleAddPromise(this.ADD_TO_CSM_CART({
        skuId: this.skuId,
        price: this.price,
        discountPrice: this.discountPrice,
      }));
    },
    handleAdd() {
      if (this.csmToken) {
        this.addCsmToCart();

        return;
      }

      this.add();
    },
    async add() {
      if (!this.skuId) {
        this.$emit('no-size-submit');

        this.$refs.notification?.shake();
        return;
      }

      if (this.success) {
        this.$emit('to-cart');
        window.location = '/checkout';
        return;
      }

      const items = [{
        productId: this.product.id,
        skuId: this.skuId,
        quantity: 1,
      }];

      this.handleAddPromise(this.ADD_TO_CART({
        items,
        storeId: this.storeId,
      }));

      this.$emit('add');

      // Google Tag Manager event
      commonGtmEvents.addToCart({ productCode: this.product?.code });

      if (this.storeId) {
        cartGtmEvents.shippingByPickup();
        cartGtmEvents.shippingByPickupStore();
      }
    },
  },
}
</script>
